@if (activePage$() && !!questionControls$()) {
  <div id="page-view__container" class="page-view__container" [class.multi-q]="visibleQuestions$().length > 1">
    @for (question of visibleQuestions$(); track question.id) {
      <empathy-question-view
        [question]="question"
        [questionCtrl]="questionControls$()[question.id]"
        [chatState]="chatState()[question.id]"
        [previewMode]="previewMode()"
        (forceStop)="forceStop$.set($event)"
        (httpError)="httpError.emit()"
      ></empathy-question-view>
    }
  </div>
}

<div @showFooter class="survey-viewer__footer">
  <empathy-viewer-progress-bar [progress]="progress$()"></empathy-viewer-progress-bar>
  <mat-toolbar class="survey-viewer__footer__toolbar">
    @if (shouldShowBackButton$()) {
      <empathy-viewer-button
        [testId]="'page-view-back-button'"
        [tooltip]="'system.previousQuestion' | translate"
        [icon]="faArrowLeft"
        [background]="'transparent'"
        [disabled]="stopBackButton$()"
        [loading]="isGoingBack$()"
        (clicked)="onPrev()"
      ></empathy-viewer-button>
    }

    <empathy-viewer-button
      [testId]="'page-view-next-button'"
      [text]="nextButtonText$()"
      [icon]="faArrowRight"
      [iconPosition]="'right'"
      [disabled]="stopNextQuestionButton$()"
      [loading]="isSaving$() || isCompleting$()"
      [loadingText]="isCompleting$() ? ('system.sending' | translate) : ('system.saving' | translate)"
      (clicked)="onNext()"
    ></empathy-viewer-button>
  </mat-toolbar>
</div>
